import type { ChipProps } from '@mui/material/Chip';
import type { AdminListWithdrawalReview } from '@mybonus/public';

export function getWithdrawlReviewChipColor(
	itemDecision: AdminListWithdrawalReview['decision'],
): ChipProps['color'] {
	switch (itemDecision) {
		case 'PENDING':
			return 'warning';
		case 'APPROVED':
			return 'success';
		case 'DENIED':
			return 'error';
	}
}
